'use client';

import * as Sentry from '@sentry/nextjs';

const COPY = {
  en: { title: 'Something went wrong.', action: 'Try again' },
  pt: { title: 'Algo deu errado.', action: 'Tentar novamente' },
  es: { title: 'Algo salió mal.', action: 'Intentar de nuevo' },
} as const;

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  Sentry.captureException(error);
  const locale =
    typeof window !== 'undefined' && window.location.pathname.startsWith('/pt')
      ? 'pt'
      : typeof window !== 'undefined' && window.location.pathname.startsWith('/es')
        ? 'es'
        : 'en';
  const copy = COPY[locale];

  return (
    <html lang={locale}>
      <body>
        <h2>{copy.title}</h2>
        <button onClick={() => reset()} type="button">
          {copy.action}
        </button>
      </body>
    </html>
  );
}
